import { createLocation } from 'history'

import type {
    AbsoluteRoutePathWithId,
    AbsoluteRoutePathWithServiceAndResourceId,
    AbsoluteRoutePathWithServiceId,
    AbsoluteRouteUpdateArgs,
    RelativeRoutePathWithId,
    RouteUpdateArgs,
} from '../Domain'
import { getAbsoluteRoute, getContext, type RouteParentPath } from '../Config'
import { createRoutingHook } from './Hook'
import { RoutingHook } from './ExternalRouteHook'

class InternalRoutingHook extends RoutingHook {
    getAbsoluteRoute (
        relativePath: RelativeRoutePathWithId
    ): AbsoluteRoutePathWithServiceId | AbsoluteRoutePathWithId | AbsoluteRoutePathWithServiceAndResourceId {
        return getAbsoluteRoute(relativePath, getContext(this.state.path))
    }

    override getParentAbsoluteRouteUpdateArgs (parent: RouteParentPath): AbsoluteRouteUpdateArgs {
        return super.getParentAbsoluteRouteUpdateArgs(parent)
    }

    createHref (...args: RouteUpdateArgs): string {
        return this.history.createHref(createLocation(this.generateRedirectionPath(...args)))
    }
}

export const useInternalRoutingHook = createRoutingHook('useInternalRoutingHook', InternalRoutingHook)
